export enum PREMIUM_MODAL_DISPLAY_PATTERN {
  NORMAL_A = 'normal_a',
  NORMAL_B = 'normal_b',
  THREE_MONTH_A = '3month_a',
  THREE_MONTH_B = '3month_b'
}

// ３カ月用デザインと通常用デザインの切り替えフラグ
export const IS_THREE_MONTH_MODE = false;
